import jsConvert from 'js-convert-case'
import { GridColumnType } from '@grid'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.locale('ko')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Seoul')

export const orderColumns: GridColumnType = {
	initRow: {
		id: '',
		seasonId: '',
		customerId: '',
		customerEmail: '',
		couponId: '',
		couponCode: '',
		couponDiscountUsd: '',
		deliveryCompany: '',
		trackingNumber: '',
		deliveryCompletedAt: '',
		receiverGivenName: '',
		receiverFamilyName: '',
		phoneCountryNumber: '',
		phoneNumber: '',
		address1: '',
		address2: '',
		city: '',
		state: '',
		zip: '',
		country: '',
		countryCode: '',
		totalUsd: 0,
		vatUsd: 0,
		shippingUsd: 0,
		discountedUsd: 0,
		paidUsd: 0,
		currency: 'USD',
		paymentMethod: '',
		paidAmount: 0,
		refundAmount: 0,
		invoiceNumber: '',
		invoiceUrl: '',
		status: '',
		channel: 'retail',
		paidAt: '',
		createdAt: '',
		deletedAt: '',
		deletedBy: '',
		updatedAt: '',
		updatedBy: '',
		preparedAt: '',
		refundedBy: '',
		refundedAt: '',
	},
	fieldToFocus: 'id',
	card: {
		title: 'id',
		status: 'status',
		subtitle: 'customerEmail',
		meta: ['createdAt', 'paidAmount', 'channel', 'country'],
		hide: ['deletedBy', 'updatedBy', 'refundedBy'],
		sections: [
			{
				title: '결제',
				fields: [
					'paidAmount',
					'currency',
					'paymentMethod',
					'totalUsd',
					'vatUsd',
					'shippingUsd',
					'discountedUsd',
					'paidUsd',
					'refundAmount',
					'invoiceNumber',
					'invoiceUrl',
				],
			},
			{
				title: '수취인',
				fields: [
					'customerId',
					'customerEmail',
					'receiverGivenName',
					'receiverFamilyName',
					'phoneCountryNumber',
					'phoneNumber',
					'address1',
					'address2',
					'city',
					'state',
					'zip',
					'country',
					'countryCode',
				],
			},
			{
				title: '배송',
				fields: [
					'boxType',
					'deliveryCompany',
					'trackingNumber',
					'shippingRateType',
					'deliveryCompletedAt',
				],
			},
			{
				title: '쿠폰',
				fields: ['couponId', 'couponCode', 'couponDiscountUsd', 'seasonId', 'channel'],
			},
			{
				title: '이력',
				fields: ['createdAt', 'preparedAt', 'updatedAt', 'refundedAt', 'deletedAt'],
			},
		],
	},
	columns: [
		{
			field: 'status',
			headerName: '상태',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'channel',
			headerName: '채널',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			width: 80,
			valueFormatter: (value: string) => (value === 'wholesale' ? '도매' : '소매'),
		},
		{
			field: 'id',
			headerName: '오더넘버',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'seasonId',
			headerName: '시즌ID',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'invoiceNumber',
			headerName: '인보이스넘버',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'invoiceUrl',
			headerName: '인보이스URL',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'customerId',
			headerName: '고객ID',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'customerEmail',
			headerName: '이메일',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'boxType',
			headerName: '박스타입',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'deliveryCompany',
			headerName: '운송회사',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'trackingNumber',
			headerName: '송장번호',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'shippingRateType',
			headerName: '운송 RATE 타입',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			valueFormatter: (value: string) => jsConvert.toHeaderCase(value),
		},
		{
			field: 'deliveryCompletedAt',
			headerName: '운송완료일자',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'receiverGivenName',
			headerName: '이름',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'receiverFamilyName',
			headerName: '성',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'phoneCountryNumber',
			headerName: '국가코드',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'phoneNumber',
			headerName: '전화번호',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'address1',
			headerName: '주소1',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'address2',
			headerName: '주소2',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'city',
			headerName: '시',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'state',
			headerName: '도',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'zip',
			headerName: '우편번호',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'country',
			headerName: '국가',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'countryCode',
			headerName: '국가코드',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'totalUsd',
			headerName: '물건가격',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'vatUsd',
			headerName: '부가세',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'shippingUsd',
			headerName: '운송비',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'discountedUsd',
			headerName: '할인가격',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'paidUsd',
			headerName: '결제금액',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'currency',
			headerName: '통화',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			width: 70,
		},
		{
			field: 'paymentMethod',
			headerName: '결제수단',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			width: 110,
		},
		{
			field: 'paidAmount',
			headerName: '청구액(통화)',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number, row: { currency?: string }) =>
				value === undefined || value === null
					? ''
					: value.toLocaleString('en-US', {
							style: 'currency',
							currency: row?.currency === 'KRW' ? 'KRW' : 'USD',
							maximumFractionDigits: row?.currency === 'KRW' ? 0 : 2,
					  }),
			align: 'right',
			width: 130,
		},
		{
			field: 'refundAmount',
			headerName: '환불액',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number, row: { currency?: string }) =>
				!value
					? ''
					: value.toLocaleString('en-US', {
							style: 'currency',
							currency: row?.currency === 'KRW' ? 'KRW' : 'USD',
							maximumFractionDigits: row?.currency === 'KRW' ? 0 : 2,
					  }),
			align: 'right',
			width: 110,
		},
		{
			field: 'couponId',
			headerName: '쿠폰ID',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'couponCode',
			headerName: '쿠폰코드',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'couponDiscountUsd',
			headerName: '쿠폰할인가격',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'createdAt',
			headerName: '생성일시',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
		},
		{
			field: 'deletedAt',
			headerName: '삭제일시',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
		},
		{
			field: 'deletedBy',
			headerName: '삭제자',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'updatedAt',
			headerName: '수정일시',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
		},
		{
			field: 'updatedBy',
			headerName: '수정자',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'preparedAt',
			headerName: '상품준비일시',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
		},
		{
			field: 'refundedBy',
			headerName: '환불자',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
		},
		{
			field: 'refundedAt',
			headerName: '환불일시',
			editable: false,
			type: 'string',
			headerAlign: 'center',
			align: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
		},
	],
}
